import { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import './Info.scss';

interface InfoProps {
  /** Bold lead-in line above the body. */
  readonly heading?: ReactNode;
  readonly children: ReactNode;
}

/**
 * An informational callout: a badged info icon beside an optional bold heading and body text. Same semantic role as inline
 * help, but a distinct accent band (e.g. the "Matchers are executed in order" intro above a list). Generic — owns its styling.
 */
export const Info = ({ heading, children }: InfoProps) => (
  <div className="info-callout">
    <span className="info-callout__badge">
      <FontAwesomeIcon icon={faInfo} />
    </span>
    <div className="info-callout__body">
      {heading !== undefined && <div className="info-callout__heading">{heading}</div>}
      <div className="info-callout__text">{children}</div>
    </div>
  </div>
);
